import { render, staticRenderFns } from "./FlatCodeView.vue?vue&type=template&id=f69d46fc&lang=pug&"
import script from "./FlatCodeView.vue?vue&type=script&lang=ts&"
export * from "./FlatCodeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports